'use client';
import { TypeDoctorCard } from './types/TypesDocsId';
import Link from 'next/link';
import { LoadingButton } from '@/components/ui/loading-button';
import { useState } from 'react';
import { formatNameDoctor } from '@/constant/scripts';
import { IoLocationOutline } from 'react-icons/io5';
import Image from 'next/image';

export default function CardSlider(props: TypeDoctorCard) {
    const {
        id,
        name,
        doctor_image,
        specialty,
        state,
        // first,
        // rate,
        // visit_count
    } = props;

    const [isclick, setIsclick] = useState(false);

    return (
        <div className="flex flex-col justify-center items-center bg-primary-shaded gap-2 px-[24px] py-3 border_box w-full size-full">
            <Image
                src={
                    doctor_image
                        ? process.env.NEXT_PUBLIC_STATIC_URL + doctor_image
                        : ''
                }
                alt={`${name}`}
                width={1000}
                height={1000}
                className="rounded-full size-[80px] object-cover"
            />
            <p className="font-semobold text-center md:!text-base sm:!max-w-full max-w-[170px] text-sm">
                {name}
            </p>
            <p className="text-black font-semobold text-center md:!text-base text-sm">
                {specialty.name}
            </p>
            <div className="gap-[2px] flex items-center text-center">
                <p>
                    <IoLocationOutline className="font-bold text-[#4A4A4A]" />
                </p>
                <p>{state}</p>
            </div>
            <LoadingButton
                disabled={isclick}
                loading={isclick}
                size={'sm'}
                asChild
                className="bg-primary h-7 lg:font-bold text-[12px]"
            >
                <Link
                    onClick={() => setIsclick(true)}
                    href={`/doctor/${id}/${formatNameDoctor(name)}`}
                >
                    دریافت نوبت
                </Link>
            </LoadingButton>
        </div>
    );
}
